import { Textarea, TextareaProps } from '@chakra-ui/react';
import { FieldPath, UseFormReturn } from 'react-hook-form';

type ConfigTemplateTextareaProps<TFieldValues> = TextareaProps & {
  name: FieldPath<TFieldValues>;
  register: UseFormReturn<TFieldValues>['register'];
};

export const ConfigTemplateTextarea = <TFieldValues,>({
  name,
  register,
  ...textareaProps
}: ConfigTemplateTextareaProps<TFieldValues>) => (
  <Textarea
    type="text"
    {...register(name, {
      required: '必須項目です。',
      validate: {
        isValid: (value) => {
          try {
            JSON.parse(value as string);

            return true;
          } catch {
            return 'JSONフォーマットで入力する必要があります。';
          }
        },
      },
    })}
    {...textareaProps}
  />
);
